import axios from "axios";
import React, { useState } from "react";
import { useSelector } from "react-redux";
// Individual MUI imports for better tree shaking
import { default as AppBarMUI } from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import CallEndIcon from "@mui/icons-material/CallEnd";
import MenuIcon from "@mui/icons-material/Menu";

import { useAppDispatch } from "../../hooks";
import { toggleDrawer } from "../../redux/slices/app";
import { show as showDialog } from "../../redux/slices/dialog";
import { logout } from "../../redux/slices/user";
import { loadContacts, saveCampaignContact } from "../../redux/slices/phone";
import { show as showSnackbar } from "../../redux/slices/snackbar";
import {
  clearCall,
  loadSIPAccount,
  setCall,
  loadCampaign,
  loadCampaignContact,
} from "../../redux/slices/phone";
import {
  convertDatetimeToStringFormat,
  secondToHHMMSS,
} from "../../helpers/datetime-helper";
import { toThousandSeperatorNumber } from "../../helpers/format-helper";
import { resultCategories, results } from "../../const/campaign-contacts";
import {
  AttachMoney,
  EmojiEmotions,
  Money,
  Sip as SipIcon,
} from "@mui/icons-material";
import { positions } from "@mui/system";
import FilterSelection from "./filter-selection";
import SIPAccountDialog from "./phone/SipAccountDialog";
import CallInfoDialog from "./phone/CallInfoDialog";
import UserMenu from "./user/UserMenu";

export function AppBar() {
  const dispatch = useAppDispatch();
  const { app, user, phone } = useSelector((state: any) => state);
  const [duration, setDuration] = useState(0);
  const [isContactDialogShown, setIsContactDialogShown] = useState(false);
  const [isSIPAccountDialogShown, setIsSIPAccountDialogShown] = useState(false);
  const [contactData, setContactData] = useState({
    note: "",
    resultCategory: "",
    customizedFields: {
      paymentDate: undefined,
      paymentAmount: undefined,
    },
    result: "",
    isDone: false,
    userId: user.id.toString(),
  });

  const handleContactDataChange = (e: any) => {
    let changingData: any = JSON.parse(JSON.stringify(contactData));
    console.log(e.target.name, e.target.value);
    console.log(changingData.customizedFields);
    changingData.customizedFields.test = 1;
    switch (e.target.name) {
      case "isDone": {
        changingData[e.target.name] = !e.target.checked;
        break;
      }
      case "paymentDate": {
        (changingData.customizedFields as any).paymentDate = e.target.value;
        break;
      }
      case "paymentAmount": {
        (changingData.customizedFields as any).paymentAmount = parseInt(
          e.target.value
        );
        break;
      }
      default: {
        changingData[e.target.name] = e.target.value;
        break;
      }
    }

    setContactData(changingData);
  };

  const handleCheckCall = () => {
    const apiURL = `https://hoankim.xyz/events-worker/`;
    const axiosConfig = {
      method: "get",
      url: apiURL,
    };
    axios(axiosConfig)
      .then(function (response) {
        let allCalls = response.data.calls;
        if (Array.isArray(allCalls)) {
          let foundCall = allCalls.find(
            (c: any) =>
              c.fromSIPAccountId === phone.SIPAccount.id ||
              c.toSIPAccountId === phone.SIPAccount.id
          );
          if (foundCall) {
            dispatch(
              setCall({
                direction: foundCall.direction,
                fromNumber: foundCall.fromNumber,
                fromSIPAccountId: foundCall.fromSIPAccountId,
                fromUserId: foundCall.fromUserId,
                toNumber: foundCall.toNumber,
                toSIPAccountId: foundCall.toSIPAccountId,
                toUserId: foundCall.toUserId,
                startedAt: foundCall.startedAt,
                answeredAt: foundCall.answeredAt,
                state: foundCall.state,
                duration: 0,
                answeredDuration: 0,
                campaignContactId: foundCall.campaignContactId,
                campaignId: foundCall.campaignId,
              })
            );
            if (foundCall.campaignContactId) {
              dispatch(loadCampaignContact(foundCall.campaignContactId));
            }
            if (foundCall.campaignId) {
              dispatch(loadCampaign(foundCall.campaignId));
            }
            if (foundCall.direction === "inbound") {
              setIsContactDialogShown(true);
              dispatch(loadContacts(foundCall.fromNumber));
            }
          }
        } else {
          dispatch(
            showSnackbar({
              title: `Hiện tại đang không có cuộc gọi nào!`,
              type: "error",
            })
          );
        }
      })
      .catch(function (error) {
        dispatch(
          showSnackbar({
            title: `Tải dữ liệu cuộc gọi lỗi!`,
            content: `${error.message}`,
            type: "error",
          })
        );
      });
  };

  const handleCheckClient = () => {
    const apiURL = `${process.env.REACT_APP_VOICE_API}/calls/originate`;
    const axiosConfig = {
      method: "post",
      url: apiURL,
      headers: {
        Authorization: `bearer ${user.accessToken}`,
        "Content-Type": "application/json",
      },
      data: {
        fromNumber: phone.SIPAccount.name,
        toNumber: phone.SIPAccount.name,
        pbxId: phone.SIPAccount.pbxId,
        fromSIPAccountId: phone.SIPAccount.id,
        toSIPAccountId: phone.SIPAccount.id,
        orgId: user.orgId,
        dialplanId: "check-client",
        direction: "outbound",
        data: {},
      },
    };
    axios(axiosConfig)
      .then(function (response) {
        dispatch(
          showSnackbar({
            title: `Cuộc gọi đang được thực hiện gọi đến Softphone/IPPhone của bạn!`,
            type: "success",
          })
        );
      })
      .catch(function (error) {
        dispatch(
          showSnackbar({
            title: `Yêu cầu kiểm tra thất bại!`,
            content: `${error.message}`,
            type: "error",
          })
        );
      });
  };

  let phoneIcon = <CallEndIcon />;
  if (phone.call.state !== "hangup") {
    if (phone.call.direction === "inbound") {
      phoneIcon = <PhoneCallbackIcon />;
    } else if (phone.call.direction === "outbound") {
      phoneIcon = <PhoneForwardedIcon />;
    }
  }
  React.useEffect(() => {
    let interval: any = null;
    if (phone.call.state === "ringing" && phone.call.direction === "inbound") {
      setIsContactDialogShown(true);
    }
    if (["ringing", "answering"].indexOf(phone.call.state) >= 0) {
      interval = setInterval(() => {
        let now = new Date();
        let newDuration = Math.floor(
          (now.getTime() - phone.call.answeredAt) / 1000
        );
        setDuration(newDuration);
      }, 1000);
    } else {
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [phone.call.state]);

  React.useEffect(() => {
    let changingContact = JSON.parse(JSON.stringify(contactData));

    changingContact.resultCategory = phone.contact.resultCategory;
    changingContact.result = phone.contact.result;
    changingContact.isDone = phone.contact.isDone;
    changingContact.note = phone.contact.note;
    changingContact.userId = user.id;
    changingContact.customizedFields = phone.contact.customizedFields;

    setContactData(changingContact);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phone.contact]);

  return (
    <React.Fragment>
      <Box sx={{ flexGrow: 1 }}>
        <AppBarMUI position="static">
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={() => dispatch(toggleDrawer())}
              >
                <MenuIcon />
              </IconButton>
            </Box>
            <Box sx={{ flexGrow: 0 }} minWidth={"100px"} marginRight={"10px"}>
              <FilterSelection />
            </Box>
            <Box sx={{ flexGrow: 0 }}>
              <UserMenu
                user={user}
                phone={phone}
                duration={duration}
                onLoginButtonClicked={() => {
                  dispatch(showDialog({ diaglogId: app.schema.loginDialogId }));
                }}
                onPhoneButtonClicked={() => {
                  setIsContactDialogShown(true);
                }}
                onSIPAccountButtonClicked={() => {
                  setIsSIPAccountDialogShown(true);
                }}
                onChangePasswordButtonClicked={() => {
                  dispatch(
                    showDialog({
                      diaglogId: app.schema.changePasswordDialogId,
                    })
                  );
                }}
                onLogoutButtonClicked={() => {
                  dispatch(logout());
                }}
              />
            </Box>
          </Toolbar>
        </AppBarMUI>
      </Box>
      <CallInfoDialog
        isShown={isContactDialogShown}
        setShown={setIsContactDialogShown}
        call={phone?.call}
        contacts={phone?.contacts}
        onTestCallSubmit={handleCheckCall}
      />
      <SIPAccountDialog
        isShown={isSIPAccountDialogShown}
        setShown={setIsSIPAccountDialogShown}
        SIPAccount={phone?.SIPAccount}
        onCheckClientSubmitted={handleCheckClient}
      />
    </React.Fragment>
  );
}
